import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '本船スケジュール',
    titleCn: '船期',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  titleCn: strings.titleCn,
  listed: true,
  staffOnly: true,
  order: 1,
};
